import { render } from "./illuminationController.vue?vue&type=template&id=130bb92e&scoped=true"
import script from "./illuminationController.vue?vue&type=script&lang=js"
export * from "./illuminationController.vue?vue&type=script&lang=js"

import "./illuminationController.vue?vue&type=style&index=0&id=130bb92e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130bb92e"]])

export default __exports__